const homepage = {
  path: 'homepage',
  redirect: to => ({
    path: '/unionLogin',
    query: {
      type: 'zk_stu',
      redirect: to.query.redirect || '/registerstudentpay/degree/index'
    }
  })
}

export default homepage
